export type Branch = {
  branch: string;
  degrees: {
    degree_name: string;
    universities: string[];
  }[];
};

export const branchesDataES: Branch[] = [
  {
    branch: 'Artes y Humanidades',
    degrees: [
      {
        degree_name: 'Grado en Bellas Artes',
        universities: [
          'Facultad de Bellas Artes (Universidad de Murcia)',
          'Facultad de Bellas Artes (UCM)',
          'Universidad Nebrija',
          'Universidade de Vigo (UVigo)',
          'Universitat Politècnica de València (UPV)',
          'ADEMA',
          'Universidad de Castilla-La Mancha (UCLM)',
          'Universidad de Sevilla (US)',
          'Universidad Complutense de Madrid (UCM)',
          'Universitat de Barcelona (UB)'
        ]
      },
      {
        degree_name: 'Grado en Estudios Clásicos',
        universities: [
          'Universidad de La Laguna (ULL)',
          'Facultad de Filología (US) (como Grado en Filología griega y latina)'
        ]
      },
      {
        degree_name: 'Grado en Estudios Ingleses',
        universities: [
          'Facultad de Bellas Artes (Universidad de Murcia) (como Grado en estudios ingleses)',
          'Universidad de La Rioja (UR)'
        ]
      },
      {
        degree_name: 'Grado en Filología Hispánica',
        universities: [
          'Universidad de Córdoba (UCO)',
          'Universitat Internacional Valenciana (VIU) (como Grado en Lengua y Literatura Españolas)'
        ]
      },
      {
        degree_name: 'Grado en Filosofía',
        universities: [
          'Universitat Abat Oliba CEU (UAO CEU)',
          'Universidad Católica de Ávila (UCAV)',
          'Universidad Autónoma de Madrid (UAM)'
        ]
      },
      {
        degree_name: 'Grado en Historia',
        universities: [
          'UDIMA Universidad a Distancia de Madrid Grados y Cursos',
          'Universitat Internacional Valenciana (VIU)',
          'Facultad de Letras (UMU)',
          'Universitat Oberta de Catalunya (UOC) (parte de Grado de Historia, Geografía e Historia del Arte)'
        ]
      },
      {
        degree_name: 'Grado en Historia del Arte',
        universities: [
          'Facultad de Letras (UMU)',
          'Universitat Oberta de Catalunya (UOC) (parte de Grado de Historia, Geografía e Historia del Arte)'
        ]
      },
      {
        degree_name: 'Grado en Lenguas Modernas',
        universities: ['Universidad de Deusto (UD)']
      },
      {
        degree_name: 'Grado en Traducción e Interpretación',
        universities: [
          'Universitat Internacional Valenciana (VIU)',
          'Universidad Pablo Olavide (UPO) (Inglés - Francés - Alemán)',
          'Facultad de Bellas Artes (Universidad de Murcia) (Francés)'
        ]
      },
      {
        degree_name: 'Grado en Conservación y Restauración de Bienes Culturales',
        universities: ['Facultad de Bellas Artes (UB)', 'Universidad de Sevilla (US)']
      },
      {
        degree_name: 'Grado en Diseño de Moda',
        universities: [
          'Easd Mestre Mateo',
          'Universidad de Diseño y Tecnología (UDIT)',
          'Universidad Nebrija',
          'Barreira Arte y Diseño',
          'ESADA - Escuela Superior de Arte y Diseño de Andalucía',
          'IED Istituto Europeo di Design - Barcelona',
          'IED Istituto Europeo di Design - Madrid',
          'Universidad Nebrija (parte de Doble Grado en Bellas Artes + Diseño de Moda)'
        ]
      },
      {
        degree_name: 'Grado Universitario en Artes y Diseño',
        universities: ['Escola Massana. Centre d´Art i Disseny']
      },
      {
        degree_name: 'Grado en Humanidades',
        universities: [
          'Universitat Oberta de Catalunya (UOC) (como Grado de Humanidades (UOC))',
          'Universitat Internacional Valenciana (VIU)',
          'Facultad de Filosofía y Letras (UAB) (como Grado de Humanidades)',
          'Facultad de Filosofía y Letras (UA) (como Grado en Humanidades)',
          'Universidad de Alicante (UA) (como Grado en Humanidades)'
        ]
      },
      {
        degree_name: 'Grado en Estudios Franceses',
        universities: [
          'Facultad de Bellas Artes (Universidad de Murcia)',
          'Facultad de Filología y Comunicación (UB)',
          'Facultad de Letras (UMU)',
          'Universidad de Sevilla (US)'
        ]
      },
      {
        degree_name: 'Grado en Diseño Gráfico',
        universities: [
          'ESADA - Escuela Superior de Arte y Diseño de Andalucía',
          'CES Escuela Superior de Imagen y Sonido',
          'Barreira Arte y Diseño',
          'IED Istituto Europeo di Design - Barcelona',
          'IED Istituto Europeo di Design - Madrid',
          'Escuela Superior de Arte del Principado de Asturias'
        ]
      },
      {
        degree_name: 'Grado en Comunicación Audiovisual',
        universities: [
          'Universidad Cardenal Herrera (CEU) (parte de Doble Grado)',
          'Universidad de Málaga (UMA)',
          'Universidad Rey Juan Carlos (URJC)',
          'Universidad San Jorge',
          'Universidad Pontificia de Salamanca (UPSA)'
        ]
      },
      {
        degree_name: 'Grado en Música',
        universities: [
          'Real Conservatorio Superior de Música de Madrid',
          'Conservatorio Superior de Música de Málaga',
          'Escola Superior de Música de Catalunya (ESMUC)'
        ]
      }
    ]
  },
  {
    branch: 'Ciencias',
    degrees: [
      {
        degree_name: 'Grado en Biotecnología',
        universities: ['Universitat Politècnica de València (UPV) (parte de Doble Grado)']
      },
      {
        degree_name: 'Grado en Ciencia y Tecnología de los Alimentos',
        universities: []
      },
      {
        degree_name: 'Grado en Ciencias Ambientales',
        universities: [
          'Universidad de Huelva (UHU)',
          'Facultad de Ciencias (UNED)',
          'Universidad de León (ULE)',
          'Escuela Politécnica Superior de Huesca (Unizar)',
          'Facultad de Ciencias Biologicas y Ambientales (ULE)',
          'Facultad de Ciencias (UMA)',
          'Universidad de Almería (UAL)',
          'Facultad de Ciencias (UEX)',
          'Universidad Rey Juan Carlos (Grados)',
          'Universidad Autónoma de Madrid (UAM)',
          'Universidad de Córdoba (UCO)',
          'Universitat Autònoma de Barcelona (UAB) (parte de Doble Grado)',
          'Universitat Politècnica de València (UPV) (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Física',
        universities: [
          'UNIE Universidad',
          'Universidad Europea (UE)',
          'Facultad de Ciencias (UAB) (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Geología',
        universities: [
          'Universidad de Huelva (UHU) (parte de Doble Grado)',
          'Universitat Autònoma de Barcelona (UAB) (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Matemáticas',
        universities: [
          'UNIE Universidad',
          'Facultad de Matemáticas e Informática (UB)',
          'Facultad de Ciencias (UAB) (también parte de Doble Grado)',
          'Facultad de Ciencias (UNIOVI)',
          'Universidad Nacional de Educación a Distancia (UNED)',
          'Universitat de Barcelona (UB)',
          'Centre de Formació Interdisciplinaria Superior (CFIS) (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Óptica y Optometría',
        universities: []
      },
      {
        degree_name: 'Grado en Química',
        universities: [
          'Universidade de Santiago de Compostela (USC)',
          'Universidad de Cantabria (UC)',
          'IQS Institut Químic de Sarrià',
          'Escuela Técnica Superior de Ingenieria (UV)',
          'Universidad de Castilla-La Mancha (UCLM)'
        ]
      },
      {
        degree_name: 'Programa conjunto en Física-Matemáticas',
        universities: ['Facultad de Ciencias (UAB) (como Grado en Física y Grado en Matemáticas)']
      },
      {
        degree_name: 'Programa conjunto en Matemáticas-Ingeniería Informática',
        universities: []
      },
      {
        degree_name: 'Grado en Bioinformática',
        universities: ['Universidad Católica de Ávila (UCAV)']
      }
    ]
  },
  {
    branch: 'Ciencias Sociales y Jurídicas',
    degrees: [
      {
        degree_name: 'Grado en Administración y Dirección de Empresas',
        universities: [
          'IGEMA Centro de Estudios Universitarios (como Grado en Administración y Dirección de Empresas ADE)',
          'Universitat Oberta de Catalunya (UOC) (como Grado de Administración y Dirección de Empresas (UOC))',
          'Universidad CUNEF (Colegio Universitario de Estudios Financieros) (como Grado en Administración y Dirección de Empresas (ADE), también parte de Doble Grado)',
          'Universitat Internacional Valenciana (VIU) (como Grado en Administración y Dirección de Empresas (ADE))',
          'Florida Universitària (con especialización en Digital Business)',
          'UNIE Universidad',
          'UDIMA Universidad a Distancia de Madrid Grados y Cursos',
          'Universitat Abat Oliba CEU (UAO) (como Grado en Dirección de Empresas y parte de Doble Grado)',
          'Universidad Cardenal Herrera (CEU) (como Grado en Dirección de Empresas y parte de Doble Grado)',
          'Esade Universidad Ramon Llull (parte de Doble Grado)',
          'Universidad Pública de Navarra (UPNA) (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Ciencias de la Actividad Física y del Deporte',
        universities: [
          'Universidad Europea',
          'Universidad de Vic - Universidad Central de Cataluña (UVic-UCC)',
          'Universidad Católica de Valencia San Vicente Mártir (UCV)',
          'Universidad de Alcalá (UAH)',
          'Universidad de Deusto'
        ]
      },
      {
        degree_name: 'Grado en Derecho',
        universities: [
          'Universitat Abat Oliba CEU (UAO) (también parte de Doble Grado)',
          'Universidad Cardenal Herrera (CEU) (también parte de Doble Grado)',
          'UNIE Universidad (Online)',
          'Universidad CUNEF (Colegio Universitario de Estudios Financieros) (parte de Doble Grado)',
          'Universitat Oberta de Catalunya (UOC) (como Grado de Derecho (UOC))',
          'ESERP Businesss & Law School (Barcelona) (parte de Doble Grado)',
          'Facultad de Ciencias Jurídicas y Económicas de la Univerdidad Camilo José Cela (UCJC) (parte de Doble Grado)',
          'Universidad Nebrija (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Economía',
        universities: [
          'UNIE Universidad',
          'Facultad de Ciencias Económicas y Empresariales (UCM)',
          'Facultad de Ciencias Económicas y Empresariales (UA)',
          'Facultad de Ciencias Económicas y Empresariales de la Universidad de Cantabria',
          'Universidad Católica de Valencia San Vicente Mártir (UCV)',
          'Facultad de Economía y Empresa (UAB)',
          'Universidad de León (ULE)',
          'Facultad de Economía y Empresa (UNIOVI)',
          'Universidad de Sevilla (US)',
          'Universitat Rovira i Virgili (URV) (como Grado de Economía)',
          'Universitat Oberta de Catalunya (UOC) (como Grado de Economía (UOC))',
          'Universidad Pública de Navarra (UPNA) (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Finanzas y Contabilidad',
        universities: []
      },
      {
        degree_name: 'Grado en Geografía y Ordenación del Territorio',
        universities: [
          'Universitat Oberta de Catalunya (UOC) (parte de Grado de Historia, Geografía e Historia del Arte)'
        ]
      },
      {
        degree_name: 'Grado en Geografía, Territorio y Medio Ambiente',
        universities: []
      },
      {
        degree_name: 'Grado en Gestión de Información y Contenidos Digitales',
        universities: []
      },
      {
        degree_name: 'Grado en Gestión y Administración Pública',
        universities: []
      },
      {
        degree_name: 'Grado en Información y Documentación',
        universities: []
      },
      {
        degree_name: 'Grado en Magisterio en Educación Infantil',
        universities: [
          'Florida Universitària (también como Grado en Maestro en Educación Infantil y parte de Doble Grado)',
          'Universitat Internacional de Catalunya (UIC) (también Grupo Bilingüe y parte de Doble Grado)',
          'Universidad Cardenal Herrera (CEU) (como Grado en Educación Infantil y parte de Doble Grado)',
          'Universitat Abat Oliba CEU (UAO) (como Grado en Educación Infantil y parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Magisterio en Educación Primaria',
        universities: [
          'Florida Universitària (también como Grado en Maestro en Educación Primaria y parte de Doble Grado)',
          'Universitat Internacional de Catalunya (UIC) (también Grupo Bilingüe y parte de Doble Grado)',
          'Universidad Católica de Ávila (UCAV) (como Grado en Maestro en Educación Primaria)',
          'Universitat Oberta de Catalunya (UOC) (como Grado de Educación Primaria (UOC))',
          'Universidad Cardenal Herrera (CEU) (parte de Doble Grado)',
          'Universitat Abat Oliba CEU (UAO) (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Marketing e Investigación de Mercados',
        universities: [
          'Universitat Oberta de Catalunya (UOC) (como Grado de Marketing e Investigación de Mercados (UOC))'
        ]
      },
      {
        degree_name: 'Grado en Periodismo',
        universities: [
          'Universidad Cardenal Herrera (CEU) (parte de Doble Grado)',
          'Universitat Abat Oliba CEU (UAO) (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Relaciones Laborales y Recursos Humanos',
        universities: []
      },
      {
        degree_name: 'Grado en Trabajo Social',
        universities: []
      },
      {
        degree_name: 'Grado en Turismo',
        universities: [
          'Escola Universitària Mediterrani (Adscrito a UdG) - EU Mediterrani (como Grado en Turismo & Digital Technologies y parte de Doble Grado)',
          'Universitat Oberta de Catalunya (UOC) (como Grado de Turismo (UOC))',
          'Escuela Universitaria de Turismo Euroaula',
          'Universidad de La Rioja (UR)',
          'Universidad de Huelva (UHU)',
          'Universidad de La Laguna (ULL)',
          'Universidad de Murcia (UMU)',
          'Escuela Universitaria de Turismo Altamira',
          'Universidad de Córdoba (UCO)',
          'Escuela Universitaria de Turismo de Lanzarote (ULPGC)',
          'Facultad de Comercio, Turismo y Ciencias Sociales Jovellanos (UNIOVI)',
          'Facultad de Filosofía y Letras (UA)',
          'CETA Escola Universitària de Turisme Barcelona - adscrita a la UdG (como Grado Universitario Oficial en Turismo)'
        ]
      },
      {
        degree_name: 'Programa conjunto en Derecho-Administración y Dirección de Empresas',
        universities: [
          'Universitat Abat Oliba CEU (UAO) (como Doble Grado en Derecho + Dirección de Empresas)',
          'Universidad Cardenal Herrera (CEU) (como Doble Grado en Dirección de Empresas y Derecho)',
          'Esade Universidad Ramon Llull (como Doble Grado en Dirección de Empresas y Derecho)',
          'Universidad CUNEF (Colegio Universitario de Estudios Financieros) (como Doble Grado Derecho y en Administración y Dirección de Empresas (ADE))'
        ]
      },
      {
        degree_name: 'Grado en Criminología',
        universities: [
          'Universitat Abat Oliba CEU (UAO) (como Grado en Criminología y Seguridad, también parte de Doble Grado)',
          'Facultad de Ciencias Jurídicas y Económicas de la Univerdidad Camilo José Cela (UCJC) (como Grado en Criminología y Seguridad)',
          'Universitat Jaume I de Castellón (UJI) (como Grado en Criminología y Seguridad)',
          'Universitat Oberta de Catalunya (UOC) (como Grado de Criminología (UOC))',
          'UNIE Universidad',
          'UDIMA Universidad a Distancia de Madrid Grados y Cursos',
          'Universidad Europea Miguel de Cervantes (UEMC)',
          'Centro de Formación Estudio Criminal',
          'Universidad Isabel I (UI) (también parte de Doble Grado)',
          'ESERP Businesss & Law School (Barcelona) (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Publicidad y Relaciones Públicas',
        universities: [
          'Universitat Abat Oliba CEU (UAO) (también parte de Doble Grado)',
          'Universitat Internacional de Catalunya (UIC)',
          'Universidad Cardenal Herrera (CEU) (también parte de Doble Grado)',
          'INSA Business, Marketing & Communication School (como Carrera Superior en Publicidad, Relaciones Públicas y Marketing)'
        ]
      },
      {
        degree_name: 'Grado en Ciencia Política y de la Administración',
        universities: [
          'Universitat Oberta de Catalunya (UOC) (como Grado en Ciencia Política y de la Administración (UOC))',
          'Universidad Cardenal Herrera (CEU) (como Grado en Ciencias Políticas y Relaciones Internacionales, también parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Sociología',
        universities: ['Universitat Oberta de Catalunya (UOC) (como Grado en Sociología (UOC))']
      },
      {
        degree_name: 'Grado en Educación Social',
        universities: [
          'Universitat Oberta de Catalunya (UOC) (como Grado de Educación Social (UOC))'
        ]
      },
      {
        degree_name: 'Grado en Marketing',
        universities: [
          'ESIC Barcelona',
          'Universidad Cardenal Herrera (CEU) (también parte de Doble Grado)',
          'INSA Business, Marketing & Communication School (como Carrera Superior en Marketing Digital & Social Media)',
          'Cámara de Comercio de Bilbao (como Grado en Gestión y Marketing Empresarial)',
          'Euncet Business School (centro adscrito a la UPC) (como Grado en Marketing, Innovación y Tecnología, también parte de Doble Grado)',
          'UNIE Universidad (como Grado en Marketing y Comunicación, también online)',
          'EAE Business School Barcelona (como Grado en Marketing y Comunicación Digital)',
          'Escola Universitària Mediterrani (Adscrito a UdG) - EU Mediterrani (como Grado en Marketing, Publicidad y RRPP y parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Seguridad',
        universities: [
          'Universidad Isabel I (UI) (como Grado en Ciencias de la Seguridad y parte de Doble Grado)',
          'Universidad Nebrija (también parte de Doble Grado)',
          'Universitat de Barcelona (UB)',
          'Escuela de Prevención y Seguridad Integral (UAB) (como Grado en Prevención y Seguridad integral)'
        ]
      }
    ]
  },
  {
    branch: 'Ingeniería y Arquitectura',
    degrees: [
      {
        degree_name: 'Grado en Arquitectura Técnica',
        universities: [
          'Escuela Universitaria Politécnica (UDC)',
          'Escuela Politécnica Superior de la Universitat de Girona (UdG) (como Grado en Arquitectura Técnica y Edificación)'
        ]
      },
      {
        degree_name: 'Grado en Estudios en Arquitectura',
        universities: [
          'Escuela Técnica Superior de Arquitectura del Vallès (ETSAV - UPC) (como Grado en Estudios de Arquitectura (ETSAV-UPC))',
          'Universidad Cardenal Herrera (CEU) (como Grado en Fundamentos de Arquitectura (Architecture))',
          'Universidad de Alicante Ingeniería y arquitectura (UA) (como Grado en Fundamentos de la Arquitectura)',
          'Universidad Politécnica de Cartagena (UPCT) (como Grado en Fundamentos de la Arquitectura)',
          'CESUGA Centro de Estudios Superiores Universitarios de Galicia (como Grado en Arquitectura)'
        ]
      },
      {
        degree_name: 'Grado en Estudios para la Defensa y Seguridad',
        universities: [
          'Universidad Nebrija (como Grado en Seguridad)',
          'Universitat de Barcelona (UB) (como Grado en Seguridad)',
          'Escuela de Prevención y Seguridad Integral (UAB) (como Grado en Prevención y Seguridad integral)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería Agroalimentaria y del Medio Rural',
        universities: [
          'Universitat Jaume I de Castellón (UJI)',
          'Universitat Politècnica de València (UPV) (también parte de Doble Grado)',
          'Escuela Politécnica Superior de Huesca (Unizar) (como Grado en Ingeniería Agroalimentaria)',
          'Escuela Politécnica Superior de la Universidad de Girona (UdG) (como Grado en Ingeniería Agroalimentaria)',
          'Universidad de Castilla-La Mancha (UCLM) (como Grado de Ingeniería Agrícola y Agroalimentaria)',
          'Universitat de Lleida (UdL) (como Grado en Ingeniería Agraria y Alimentaria)',
          'Escuela Politécnica Superior de Orihuela (UMH) (como Grado de Ingeniero agronómo)',
          'Escuela Politécnica Superior (USC) Campus Lugo (como Grado en Ingeniería de las Industrias Agroalimentarias)',
          'Universidad de La Laguna (ULL) (como Grado en Ingeniería Agrícola y del Medio Rural)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería Biomédica',
        universities: ['Universitat Internacional de Catalunya (UIC) (como Grado en Bioingeniería)']
      },
      {
        degree_name: 'Grado en Ingeniería Civil',
        universities: [
          'Universidad de Alicante Ingeniería y arquitectura (UA) (también como Grado de Ingeniería Civil)',
          'Universidad Alfonso X El Sabio (UAX) (como Grado en Ingeniería Civil en Construcciones Civiles)',
          'Universidad de Castilla-La Mancha (UCLM) (como Grado en Ingeniería Civil y Territorial)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería de Datos en Procesos Industriales',
        universities: [
          'Universitat Oberta de Catalunya (UOC) (como Grado en Ciencia de Datos Aplicada (Applied Data Science))',
          'Universidad CUNEF (Colegio Universitario de Estudios Financieros) (parte de Doble Grado en Inteligencia Artificial y Ciencia de Datos)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería de Organización Industrial',
        universities: [
          'Universitat Internacional Valenciana (VIU)',
          'EUSS (como Grado en Ingeniería en Organización industrial)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería de Tecnologías de Telecomunicación',
        universities: [
          'Universitat Oberta de Catalunya (UOC) (como Grado de Ingeniería de Tecnologías y Servicios de Telecomunicación)',
          'Universitat Internacional Valenciana (VIU) (como Grado en Ingeniería de Tecnologías y Servicios de Telecomunicación)',
          'Escuela Técnica Superior de Ingenieria (UV) (como Grado en Ingeniería Electrónica de Telecomunicación)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería de Tecnologías Industriales',
        universities: [
          'Universidad de Cantabria (UC)',
          'Escuela Politécnica Superior de la Universitat de Girona (UdG)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería Eléctrica',
        universities: [
          'Universidad de Sevilla (US)',
          'Escuela de Ingeniería de Terrassa (EET - UPC) (como Grado en Ingeniería Eléctrica (EET - UPC))',
          'Escuela Politécnica Superior (UALM)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería Electrónica Industrial y Automática',
        universities: [
          'Universidad Católica de Ávila (UCAV)',
          'EHU Escuela universitaria de ingeniería de Vitoria-Gasteiz',
          'Universidad de Castilla-La Mancha (UCLM)',
          'Florida Universitària (también parte de Doble Grado)',
          'Universitat Rovira i Virgili (URV)',
          'EUSS (también parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería en Diseño Industrial y Desarrollo de Producto',
        universities: ['Dirección de Enseñanza Virtual (UMA) (también parte de Doble Grado)']
      },
      {
        degree_name: 'Grado en Ingeniería Informática',
        universities: [
          'Universidad de Alicante Ingeniería y arquitectura (UA)',
          'Universitat Oberta de Catalunya (UOC) (como Grado de Ingeniería Informática)',
          'UNIE Universidad (como Grado de Ingeniería Informática)',
          'Universidad CUNEF (Colegio Universitario de Estudios Financieros) (como Grado de Ingeniería Informática y parte de Doble Grado)',
          'Universidad Católica de Ávila (UCAV) (como Grado de Ingeniería Informática)',
          'Escuela Técnica Superior de Ingenieria (UV) (también como Grado de Ingeniería Informática)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería Mecánica',
        universities: [
          'Universidad de Sevilla (US)',
          'EPS Escuela Superior de Jaén',
          'Dirección de Enseñanza Virtual (UMA) (parte de Doble Grado)',
          'EUSS (parte de Doble Grado)',
          'Florida Universitària (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería Mecatrónica',
        universities: []
      },
      {
        degree_name: 'Grado en Ingeniería Química',
        universities: [
          'Facultad de Ciencias (UMA) (como Grado en Ingeniería química (UMA))',
          'Escuela Técnica Superior de Ingenieria (UV)',
          'Universidad de Castilla-La Mancha (UCLM)',
          'Universidade de Santiago de Compostela (USC)',
          'Universidad de Cantabria (UC)',
          'IQS Institut Químic de Sarrià',
          'EPS Escuela Superior de Jaén (como Grado en Ingeniería Química Industrial)'
        ]
      },
      {
        degree_name:
          'Programa conjunto en Ingeniería Informática-Administración y Dirección de Empresas',
        universities: [
          'Universidad CUNEF (Colegio Universitario de Estudios Financieros) (como Doble Grado en Administración y Dirección de Empresas (ADE) e Ingeniería Informática)'
        ]
      },
      {
        degree_name:
          'Programa conjunto en Ingeniería Mecatrónica-Ingeniería de Organización Industrial',
        universities: []
      },
      {
        degree_name: 'Grado en Edificación',
        universities: [
          'Escuela Técnica Superior de Edificación (UPM)',
          'Universidad Católica San Antonio de Murcia (UCAM)',
          'Escuela de Arquitectura y Tecnología de la Universidad Camilo José Cela (UCJC)',
          'Universidad de Sevilla (US)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería de la Edificación',
        universities: [
          'Escuela Politécnica Superior de la Universidad de Girona (UdG)',
          'Universidad Politécnica de Cartagena (UPCT)',
          'Escuela Politécnica de Cuenca (UCLM)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería Ambiental',
        universities: [
          'Universidad Rey Juan Carlos (Grados)',
          'Universitat Politècnica de València (UPV) (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería de la Energía',
        universities: [
          'Universidad Rey Juan Carlos (Grados)',
          'Academia CPI - Centro de Preparación de Ingenieros',
          'Universitat de Lleida (UdL) (como Grado en Ingeniería de la Energía y Sostenibilidad)',
          'Universidad de León (ULE) (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería de Minas y Recursos Energéticos',
        universities: [
          'Universidad de Cantabria (UC) (como Grado en Ingeniería de los Recursos Energéticos)',
          'EPS Escuela Superior de Jaén (como Grado en Ingeniería de Recursos Energéticos)',
          'Universidad de Córdoba (UCO) (como Grado de Ingeniería en Recursos energéticos y mineros)',
          'Universidad de Jaén (UJA) (como Grado en Ingeniería de Tecnologías Mineras)',
          'Escuela Politécnica Superior de Ingeniería de Manresa (EPSEM - UPC) (como Grado en Ingeniería de Recursos Energéticos y Mineros - EPSEM)',
          'Universidad de Huelva (UHU) (como Grado en Ingeniería en Explotación de Minas y Recursos Energéticos)',
          'uniovi - Escuela Técnica Superior de Ingeniería de Minas de Oviedo (como Grado en ingeniería y tecnología de minas)'
        ]
      },
      {
        degree_name: 'Grado en Ingeniería de Diseño y Tecnologías Creativas',
        universities: [
          'Universidad de Diseño y Tecnología (UDIT) (como Grado en Diseño Multimedia y Gráfico)',
          'Universidad Camilo José Cela (UCJC) (como Grado en Artes Digitales)',
          'Elisava Facultad de Diseño e Ingeniería de Barcelona (UVic-UCC) (como Grado en Diseño)'
        ]
      },
      {
        degree_name: 'Grado en Logística y Transporte',
        universities: ['Universidad Camilo José Cela (UCJC)']
      },
      {
        degree_name: 'Grado en Ingeniería Aeronáutica',
        universities: [
          'Universidad Politécnica de Madrid (UPM)',
          'Universidad de León (ULE)',
          'Universidad Carlos III de Madrid (UC3M)'
        ]
      }
    ]
  },
  {
    branch: 'Ciencias de la Salud',
    degrees: [
      {
        degree_name: 'Grado en Enfermería',
        universities: [
          'Universidad Cardenal Herrera (CEU) (también como Spanish Pathway to Nursing)',
          'Universidad Católica de Valencia San Vicente Mártir (UCV)'
        ]
      },
      {
        degree_name: 'Grado en Fisioterapia',
        universities: [
          'Universidad Cardenal Herrera (CEU) (también parte de Doble Grado)',
          'Universidad Católica de Ávila (UCAV)',
          'Universidad de Vic - Universidad Central de Cataluña (UVic-UCC)'
        ]
      },
      {
        degree_name: 'Grado en Medicina',
        universities: [
          'Universidad Cardenal Herrera (CEU) (también como Degree in Medicine)',
          'Universidad de Navarra (UNAV)',
          'Universidad Complutense de Madrid (UCM)'
        ]
      },
      {
        degree_name: 'Grado en Nutrición Humana y Dietética',
        universities: [
          'Universidad de Alicante (UA)',
          'Universidad de Navarra (UNAV)',
          'Universidad Complutense de Madrid (UCM)'
        ]
      },
      {
        degree_name: 'Grado en Odontología',
        universities: [
          'Universidad Cardenal Herrera (CEU) (también como Grado en Odontología (Dentistry))',
          'Universitat Internacional de Catalunya (UIC)'
        ]
      },
      {
        degree_name: 'Grado en Psicología',
        universities: [
          'Universidad Cardenal Herrera (CEU)',
          'UNIE Universidad',
          'Universitat Internacional de Catalunya (UIC) (parte de Doble Grado)',
          'Universitat Abat Oliba CEU (UAO) (también con Certificado y parte de Doble Grado)',
          'Universidad Católica Santa Teresa de Jesús de Ávila (parte de Doble Grado)'
        ]
      },
      {
        degree_name: 'Grado en Terapia Ocupacional',
        universities: [
          'Universidad Rey Juan Carlos (URJC)',
          'Universidad de Castilla-La Mancha (UCLM)'
        ]
      },
      {
        degree_name: 'Grado en Veterinaria',
        universities: [
          'Universidad Cardenal Herrera (CEU) (también como Grado en Veterinaria (Veterinary Medicine))',
          'Universidad de León (ULE)',
          'Facultad de Veterinaria (UPGC)',
          'Universidad Católica de Valencia San Vicente Mártir (UCV)',
          'Universidad de Zaragoza (UNIZAR)',
          'Facultad de Veterinaria (UAB)',
          'Facultad de Veterinaria (UCO)',
          'Universidad de Extremadura (UEX)',
          'Universidad de Córdoba (UCO)',
          'Facultad de Veterinaria (UCM)',
          'Universidad Alfonso X El Sabio (UAX)',
          'Universidade de Santiago de Compostela (USC)',
          'Universitat de Lleida (UdL) (parte de Doble Grado)'
        ]
      },
      {
        degree_name:
          'Programa conjunto en Nutrición Humana y Dietética-Ciencias de la Actividad Física y del Deporte',
        universities: []
      },
      {
        degree_name: 'Grado en Farmacia',
        universities: [
          'Universidad Cardenal Herrera (CEU) (también como Grado en Farmacia (Pharmacy))',
          'Universidad Católica de Ávila (UCAV)',
          'Universitat de Barcelona (UB)'
        ]
      },
      {
        degree_name: 'Grado en Logopedia',
        universities: ['Universitat Oberta de Catalunya (UOC) (interuniversitario: UVic-UCC, UOC)']
      },
      {
        degree_name: 'Grado en Biomedicina',
        universities: ['UNIE Universidad', 'Universitat de Barcelona (UB)']
      }
    ]
  }
];

export const branchesDataPT: Branch[] = [
  {
    branch: 'Ciências da Saúde',
    degrees: [
      {
        degree_name: 'Licenciatura em Enfermagem',
        universities: [
          'Escola Superior de Enfermagem de Coimbra (ESEnfC) - Instituto Politécnico de Coimbra',
          'Escola Superior de Enfermagem de Lisboa (ESEL) - Instituto Politécnico de Lisboa',
          'Escola Superior de Saúde do Instituto Politécnico do Porto (ESS/IPP)',
          'Universidade do Porto - Faculdade de Medicina (unidades associadas)',
          'Universidade de Coimbra - Escola Superior de Enfermagem Dr. Fontes Pereira de Melo',
          'Escola Superior de Saúde da Universidade Católica Portuguesa (UCP - Porto/Lisboa)'
        ]
      },
      {
        degree_name: 'Licenciatura em Fisioterapia',
        universities: [
          'Universidade do Porto (UPorto)',
          'Universidade do Minho (UMinho)',
          'Universidade de Coimbra (UC)',
          'Escola Superior de Saúde do Instituto Politécnico de Leiria (ESSLei)',
          'Escola Superior de Saúde de Alcoitão (privada)'
        ]
      },
      {
        degree_name: 'Licenciatura em Ciências Biomédicas / Ciências Biomédicas e da Saúde',
        universities: [
          'Universidade de Aveiro (UA)',
          'Universidade do Algarve (UAlg)',
          'Universidade de Évora (UÉvora)',
          'Universidade de Lisboa (ULisboa) - Unidades associadas'
        ]
      },
      {
        degree_name: 'Licenciatura em Ciências da Nutrição',
        universities: [
          'Universidade do Porto (UPorto)',
          'Universidade de Coimbra (UC)',
          'Universidade de Trás-os-Montes e Alto Douro (UTAD)',
          'Universidade do Algarve (UAlg)'
        ]
      },
      {
        degree_name: 'Licenciatura em Ciências do Desporto',
        universities: [
          'Universidade da Beira Interior (UBI)',
          'Universidade do Porto (UPorto)',
          'Universidade de Coimbra (UC)',
          'Universidade do Minho (UMinho)'
        ]
      },
      {
        degree_name: 'Licenciatura em Tecnologias da Saúde / Ciência Biomédica Laboratorial',
        universities: [
          'Escola Superior de Saúde do Instituto Politécnico de Bragança (IPB)',
          'Escola Superior de Saúde do Instituto Politécnico do Porto (ESS/IPP)',
          'Escola Superior de Saúde do Instituto Politécnico de Leiria (ESSLei)'
        ]
      },
      {
        degree_name: 'Licenciatura em Serviço Social',
        universities: [
          'Instituto Politécnico de Lisboa (IPLisboa) - Escola Superior de Comunicação Social/Unidades',
          'Instituto Politécnico de Coimbra (IPC) - Escola Superior de Educação e Ciências Sociais',
          'Universidade de Évora - Escola de Ciências Humanas',
          'Instituto Politécnico de Setúbal (IPS) - Escola Superior de Educação'
        ]
      }
    ]
  },
  {
    branch: 'Engenharia e Tecnologia',
    degrees: [
      {
        degree_name: 'Licenciatura em Engenharia Informática',
        universities: [
          'Instituto Superior Técnico (IST) - Universidade de Lisboa',
          'Universidade do Porto (FEUP / Faculdade de Engenharia)',
          'Universidade de Aveiro (UA)',
          'Instituto Politécnico de Lisboa - ISEL',
          'Universidade do Minho (UMinho)'
        ]
      },
      {
        degree_name: 'Licenciatura em Engenharia Civil',
        universities: [
          'Instituto Superior Técnico (IST)',
          'Universidade do Porto (FEUP)',
          'Universidade de Coimbra (UC)'
        ]
      },
      {
        degree_name: 'Licenciatura em Engenharia Mecânica',
        universities: [
          'Universidade de Aveiro (UA)',
          'Universidade do Porto (FEUP)',
          'Instituto Politécnico do Porto - ISEP'
        ]
      },
      {
        degree_name: 'Licenciatura em Engenharia Eletrotécnica',
        universities: [
          'Instituto Superior Técnico (IST)',
          'Instituto Politécnico do Porto - ISEP',
          'Universidade do Porto (FEUP)'
        ]
      },
      {
        degree_name: 'Licenciatura em Engenharia do Ambiente',
        universities: [
          'Universidade Nova de Lisboa (NOVA FCT)',
          'Universidade de Aveiro (UA)',
          'Instituto Politécnico de Castelo Branco - Escola Superior de Tecnologia'
        ]
      },
      {
        degree_name: 'Licenciatura em Engenharia Química / Química Industrial (1.º ciclo)',
        universities: [
          'Universidade de Coimbra (UC)',
          'Universidade do Porto (UPorto)',
          'Universidade de Aveiro (UA)'
        ]
      },
      {
        degree_name: 'Licenciatura em Engenharia de Telecomunicações / Eletrónica',
        universities: [
          'Instituto Superior Técnico (IST)',
          'Universidade do Porto (FEUP)',
          'Universidade de Aveiro (UA)'
        ]
      },
      {
        degree_name: 'Licenciatura em Engenharia Biomédica (quando exista 1.º ciclo)',
        universities: [
          'Algumas universidades / politécnicos (ver DGES/A3ES para cada edição concreta)'
        ]
      }
    ]
  },
  {
    branch: 'Ciências Sociais e Humanas',
    degrees: [
      {
        degree_name: 'Licenciatura em Psicologia',
        universities: [
          'Universidade de Lisboa (ULisboa)',
          'Universidade do Porto (UPorto)',
          'Universidade do Minho (UMinho)',
          'Universidade de Coimbra (UC)'
        ]
      },
      {
        degree_name: 'Licenciatura em Sociologia',
        universities: [
          'Universidade do Porto (UPorto)',
          'Universidade do Minho (UMinho)',
          'Universidade de Coimbra (UC)'
        ]
      },
      {
        degree_name: 'Licenciatura em Antropologia',
        universities: ['Universidade Nova de Lisboa (UNL)', 'Universidade do Minho (UMinho)']
      },
      {
        degree_name: 'Licenciatura em História',
        universities: [
          'Universidade de Coimbra (UC)',
          'Universidade de Lisboa (ULisboa)',
          'Universidade do Porto (UPorto)'
        ]
      },
      {
        degree_name: 'Licenciatura em Filosofia',
        universities: ['Universidade de Coimbra (UC)', 'Universidade de Lisboa (ULisboa)']
      },
      {
        degree_name: 'Licenciatura em Ciências da Comunicação',
        universities: [
          'Universidade Nova de Lisboa (UNL) - Faculdade de Ciências Sociais e Humanas',
          'Universidade do Porto (UPorto)'
        ]
      },
      {
        degree_name: 'Licenciatura em Educação Social',
        universities: [
          'Instituto Politécnico de Lisboa - Escola Superior de Educação',
          'Instituto Politécnico de Coimbra - Escola Superior de Educação e Ciências Sociais'
        ]
      },
      {
        degree_name: 'Licenciatura em Ciência Política e Relações Internacionais',
        universities: ['Universidade de Lisboa (ULisboa) - ISCTE', 'Universidade do Minho (UMinho)']
      }
    ]
  },
  {
    branch: 'Economia e Gestão',
    degrees: [
      {
        degree_name: 'Licenciatura em Economia',
        universities: [
          'Universidade de Lisboa (ULisboa) - Faculdade de Economia',
          'Universidade do Porto (UPorto) - Faculdade de Economia',
          'Universidade Nova de Lisboa (NOVA FCSH / ISEG)'
        ]
      },
      {
        degree_name: 'Licenciatura em Gestão',
        universities: [
          'Universidade Católica Portuguesa (UCP) - Porto/Lisboa',
          'Universidade do Porto (UPorto)',
          'Universidade de Lisboa (ULisboa)'
        ]
      },
      {
        degree_name: 'Licenciatura em Finanças',
        universities: [
          'Universidade do Porto (UPorto)',
          'Universidade de Lisboa (ULisboa)',
          'Instituto Politécnico de Leiria - ESTG'
        ]
      },
      {
        degree_name: 'Licenciatura em Contabilidade',
        universities: [
          'Universidade do Minho (UMinho)',
          'Instituto Politécnico de Santarém (IPSantarém)',
          'Instituto Politécnico de Aveiro (IPAAveiro)'
        ]
      },
      {
        degree_name: 'Licenciatura em Marketing',
        universities: [
          'Universidade Católica Portuguesa (UCP)',
          'Instituto Politécnico do Porto (IPP) - ESEC / ESCE'
        ]
      }
    ]
  },
  {
    branch: 'Ciências Exatas e Naturais',
    degrees: [
      {
        degree_name: 'Licenciatura em Matemática',
        universities: [
          'Universidade de Lisboa (ULisboa)',
          'Universidade do Porto (UPorto)',
          'Universidade de Coimbra (UC)'
        ]
      },
      {
        degree_name: 'Licenciatura em Física',
        universities: ['Universidade de Lisboa (ULisboa)', 'Universidade do Porto (UPorto)']
      },
      {
        degree_name: 'Licenciatura em Química',
        universities: [
          'Universidade de Coimbra (UC)',
          'Universidade de Lisboa (ULisboa)',
          'Universidade do Porto (UPorto)'
        ]
      },
      {
        degree_name: 'Licenciatura em Biologia',
        universities: [
          'Universidade do Porto (UPorto)',
          'Universidade de Lisboa (ULisboa)',
          'Universidade de Aveiro (UA)'
        ]
      },
      {
        degree_name: 'Licenciatura em Ciências do Mar',
        universities: ['Universidade dos Açores (UAc)', 'Universidade do Algarve (UAlg)']
      },
      {
        degree_name: 'Licenciatura em Geologia / Engenharia Geológica (1.º ciclo quando aplicável)',
        universities: [
          'Universidade de Coimbra (UC)',
          'Universidade de Lisboa (ULisboa)',
          'Universidade do Porto (UPorto)'
        ]
      }
    ]
  },
  {
    branch: 'Artes e Design',
    degrees: [
      {
        degree_name: 'Licenciatura em Belas-Artes',
        universities: [
          'Faculdade de Belas-Artes da Universidade de Lisboa (FBAUL)',
          'Faculdade de Belas-Artes da Universidade do Porto (FBAUP)',
          'Escola Superior de Artes e Design (ESAD.CR) - Politécnico de Leiria'
        ]
      },
      {
        degree_name: 'Licenciatura em Design (Design de Comunicação / Design de Produto)',
        universities: [
          'Universidade de Aveiro (UA)',
          'Universidade do Porto (UPorto) - Faculdade de Belas-Artes / ESAD',
          'Universidade Católica Portuguesa (UCP) - Escola das Artes'
        ]
      },
      {
        degree_name: 'Licenciatura em Música',
        universities: [
          'Conservatório de Música - Universidades e Escolas Superiores (variantes: UCP, UMinho, UPorto)',
          'Universidade do Minho (UMinho) - Escola de Música'
        ]
      },
      {
        degree_name: 'Licenciatura em Teatro / Artes Performativas',
        universities: [
          'Universidade de Évora - Escola de Artes',
          'Escolas superiores artísticas (varias unidades politécnicas e privadas)'
        ]
      }
    ]
  },
  {
    branch: 'Direito',
    degrees: [
      {
        degree_name: 'Licenciatura em Direito',
        universities: [
          'Faculdade de Direito da Universidade de Lisboa (FDUL)',
          'Faculdade de Direito da Universidade do Porto (FDUP)',
          'Faculdade de Direito da Universidade de Coimbra (FDUC)',
          'Universidade Nova de Lisboa (Faculdade de Direito)',
          'Universidade Católica Portuguesa (UCP) - Porto/Lisboa (onde aplicável)'
        ]
      },
      {
        degree_name:
          'Licenciatura em Criminologia / Direito e Criminologia (quando haja 1.º ciclo)',
        universities: ['Universidade Nova de Lisboa (UNL) - programas especializados / unidades']
      }
    ]
  },
  {
    branch: 'Educação',
    degrees: [
      {
        degree_name: 'Licenciatura em Educação Básica',
        universities: [
          'Escolas Superiores de Educação (varias: IPLeiria - ESECS, IPLeiria - ESTG, IPLeiria - ESAD; IPCoimbra - ESE; IPLisboa - ESEL)',
          'Universidade Lusófona (ULusófona) - Instituto de Educação'
        ]
      },
      {
        degree_name: 'Licenciatura em Ciências da Educação',
        universities: [
          'Universidade Católica Portuguesa (UCP)',
          'Universidade do Minho (UMinho)',
          'Universidade de Lisboa (ULisboa)'
        ]
      },
      {
        degree_name: 'Licenciatura em Tecnologias Digitais Educativas',
        universities: [
          'Universidade Aberta (UAb) - quando disponible como 1.º ciclo',
          'Institutos politécnicos que ofrecen itinerários em educação/tecnologia'
        ]
      }
    ]
  }
];
